import React, { Component } from "react";

class Socket extends Component {
    state = {
        eventoSocket: null,
        socket: null,
    }

    componentDidMount() {
        const id = this.props.id
        const socket = new WebSocket(process.env.REACT_APP_SOCKET);
        socket.addEventListener("open", function () {
            socket.send(
                JSON.stringify({ action: "setInformation", number: id })
            );
        });
        socket.addEventListener("message", (event) => {
            if (event.data !== '{"data":{"message":"soket"}}') {
                this.props.viewMessage(JSON.parse(event.data))
            }
        });
        this.setState({ socket: socket });

    }

    async componentWillUnmount() {
        if (this.state.socket !== null) {
            await this.state.socket.send(
                JSON.stringify({
                    action: "$disconnect",
                })
            );
        }
    }

    render() {
        return <div></div>
    }
}

export default Socket;